<template>
  <div class="mapdiv">
    <div id="allmap" ref="gmap">

      <div v-if="showErrMessage" class="errTip">Map loading failed</div>

      <Spin fix :show="dituloading">
        <Icon type="ios-loading" size=18 class="demo-spin-icon-load"></Icon>
        <div>Loading</div>
      </Spin>

    </div>
    <Loding v-if="!dituloading" :showLoding="loading" :centerAbsolute="true"></Loding>

  </div>
</template>
<script>
import common from "@/common/common.js";
import Loding from "../../common/Loding.vue";
import { Loader } from "@googlemaps/js-api-loader"
import { MarkerClusterer, defaultOnClusterClickHandler } from "@googlemaps/markerclusterer"
import { asyncLoadJs } from '@/libs/map'
import { countryList as countryListJson } from './json/countryList'
import { mapState } from "vuex";

export default {
  name: 'gmap',
  props: {
    searchObj: {
      type: Object,
      default: () => {
        return {
          status: 2,//已激活
          productTypeId: '',
          whetherOnline: ''
        }
      }
    },
    centerGeo: {
      type: Object,
      default: () => {
        return {
          lng: -95.7129,
          lat: 37.0902,
          two_letter_code: 'US'
        }
      }
    },
  },
  components: {
    Loding
  },
  data() {
    return {
      map: null,
      markerClusterer: '',
      infowindowPoint: '',
      level: 1,
      zoom: 5,
      lableMarkers: [],
      iconIndex: 2,
      iconColor: '#1296db',
      timerMapGetdata: '',
      loading: false,
      dituloading: true,
      showErrMessage: false,
      geocoder: '',//位置与经纬度转换
      visibleRegionCountryList: [],
      countryListMove: [],
      dataCountryListAll: [],//国家数据汇总
      dataCountryList: [],//国家数据汇总
      dataCityList: [],//城市数据汇总
      countryClick: false,
      deviceList: [],//设备列表
    }
  },
  watch: {
    centerGeo: {
      deep: true,
      handler(newval) {
        this.map.setCenter({ lat: newval.lat, lng: newval.lng })
      }
    },
    // local() {
    //    window.location.reload();
    // },
  },
  computed: {
    ...mapState(["local"])
  },

  created() {

  },
  mounted() {
    this.$nextTick(() => {
      this.googleMap()
    })
  },
  methods: {
    async googleMap() {//引入谷歌地图
      let that = this

      this.loader = new Loader({
        // apiKey: 'AIzaSyDy-zJzil2780s-ZIwf2O3l9nGV-mtZzak',
        apiKey: 'AIzaSyAtg-kfUYxD-IRCMWqNioFEujBv8qGRN_4',
        version: 'weekly',
        // language: this.local=='zh-CN'?'zh-CN':'en'
        language: 'en'
      });

      // 创建定时器，超时后显示错误信息
      let timeout = setTimeout(() => {
        if (that.dituloading) {
          this.showErrMessage = true;
          that.dituloading = false;
        }
      }, 6000); // 设置超时为 6 秒

      this.loader.load().then(() => {
        clearTimeout(timeout);
        that.dituloading = false
        this.showErrMessage = false
        console.log('process.env.NODE_ENV', process.env.NODE_ENV)
        asyncLoadJs(process.env.NODE_ENV === 'development' ? 'googlemap/MarkerWithLabel.js' : 'static/googlemap/MarkerWithLabel.js').then(() => {

          this.initMap()
        })
      }).catch(err => {
        that.dituloading = false
        that.showErrMessage = true
      })

    },
    initMap() { //地图初始化
      // console.log('google', google)
      let that = this
      this.map = new google.maps.Map(document.getElementById("allmap"), {
        zoom: 4,
        center: { lat: that.centerGeo.lat, lng: that.centerGeo.lng },//
        minZoom: 4,
        maxZoom: 20,
        mapTypeControl: false,
        streetViewControl: false,
      });


      this.geocoder = new google.maps.Geocoder();



      //  当地图在平移或缩放后变为空闲时,将触发此事件
      google.maps.event.addListener(this.map, 'idle', async () => {
        this.zoom = this.map.getZoom();
        // console.log('this.zoom ', this.zoom)
        this.level = (this.zoom < 5) ? 1 : ((this.zoom >= 5 && this.zoom <= 9) ? 2 : 4); //1--国家，2--省城市，4--其他  zoom：1：世界,5：大陆/洲,10：城市,15：街道,20：建筑物)。

        if (this.timerMapGetdata) {
          clearTimeout(this.timerMapGetdata)
        }
        console.log('this.zoom',this.zoom)
        this.timerMapGetdata = setTimeout(async () => {
          // 获取可视区域国家列表
          await this.getVisibleRegionCountry()
        
          if (this.zoom < 10 && !this.countryClick) {
            // 根据国家列表，获取城市汇总数据
            await this.getInitData(this.countryListMove)
            // 渲染地图
            await this.echarsHeatmap();
          }

          // 缩小后再次放大渲染之前的数据
          // if (this.zoom >= 10 && this.deviceList.length) {
          //   await this.getIconClusterLayer()
          // }

        }, 800);

      });




    },
    echarsHeatmap(obj = {}) {//渲染地图
      // 清除覆盖物
      this.removePoints()

      // console.log(this.MarkerListLayer)
      // 1.当请求级别是4的时候，谷歌地图自动集合；
      // 2.当请求级别小于4，使用后台做聚合查询，前端label展示。
      // console.log('points',points)
      // if (level != 4) {
      //   this.getLabelLayer()
      // } else {
      //   this.getIconClusterLayer()
      // }

      this.getLabelLayer()


    },
    // 传国家，给所有城市的设备汇总，展示国家
    async getInitData(countryList) {
      let params = {
        countryList: countryList,
        productTypeId: (this.searchObj.productTypeId === undefined || this.searchObj.productTypeId === '') ? null : this.searchObj.productTypeId * 1,
        whetherOnline: (this.searchObj.whetherOnline === undefined || this.searchObj.whetherOnline === '') ? null : this.searchObj.whetherOnline * 1
      }
      if (!countryList.length) return
      this.loading = true
      let result = await this.axios.post(this.config.urlArray.getCountOfEachCity, { ...params })
      if (result) {
        common.ajaxMsg(result.data, false, () => {
          let resData = result.data.data
          let dataList = []

          resData.map(item => {
            let cityCenter = null
            for (let i = 0; i < countryListJson.length; i++) {
              if (countryListJson[i].two_letter_code == item.country) {
                cityCenter = [countryListJson[i].lng * 1, countryListJson[i].lat * 1]
                break;
              }
            }

            let totalCount
            totalCount = item.citys.reduce((sum3, obj) => (sum3 += obj.theCount), 0);

            let number = totalCount >= 10000 ? Math.round(totalCount / 1000) + 'k'
              : totalCount >= 1000 ? Math.round(totalCount / 100) / 10 + 'k' : totalCount;


            if (totalCount > 0) {

              dataList.push({
                geometry: {
                  type: 'Point',
                  lng: cityCenter[0],
                  lat: cityCenter[1]
                },
                properties: {
                  text: number,
                  country: item.country,
                  totalCount: totalCount,
                  number: number
                }
              })
            }
          })

          this.dataCountryList = dataList
          this.dataCountryListAll = resData
          
        });
      }
      this.loading = false
    },
    // 展示某个国家所有城市列表
    getCityDataByCounty(country) {
      // console.log('country', country)
      let dataList = []
      let cityList = []
      for (let i = 0; i < this.dataCountryListAll.length; i++) {
        if (this.dataCountryListAll[i].country == country) {
          cityList = this.dataCountryListAll[i].citys
          break;
        }
      }

      // console.log('cityList', cityList)

      if (!cityList.length) return

      cityList.map(async (item) => {

        let lng = ''
        let lat = ''
        const result = await this.geocodeSync(country + ' ' + item.statisticCityName);
        if (result) {
          lng = result.geometry.location.lng()
          lat = result.geometry.location.lat()

          let number = item.theCount >= 10000 ? Math.round(item.theCount / 1000) + 'k'
            : item.theCount >= 1000 ? Math.round(item.theCount / 100) / 10 + 'k' : item.theCount;

          dataList.push({
            geometry: {
              type: 'Point',
              lng: lng,
              lat: lat
            },
            properties: {
              text: number,
              country: country,
              city: item.statisticCityName,
              totalCount: item.theCount,
              number: number
            }
          })
        }
      })

      this.dataCityList = dataList
      console.log('this.dataCityList', this.dataCityList)

    },
    // 用于添加轻微的随机偏移量
    getRandomOffset() {
      const offset = 0.0002; // 偏移量的大小，根据需要调整
      const latOffset = (Math.random() - 0.5) * offset; // 随机纬度偏移
      const lngOffset = (Math.random() - 0.5) * offset; // 随机经度偏移
      return { latOffset, lngOffset };
    },
    // 传城市，给改城市的设备列表
    async getDetailData(country, cityName) {
      if (!cityName) return
      let params = {
        simpleCountryName: country,
        statisticCityName: cityName,
        productTypeId: (this.searchObj.productTypeId === undefined || this.searchObj.productTypeId === '') ? null : this.searchObj.productTypeId * 1,
        whetherOnline: (this.searchObj.whetherOnline === undefined || this.searchObj.whetherOnline === '') ? null : this.searchObj.whetherOnline * 1
      }
      this.loading = true
      let result = await this.axios.post(this.config.urlArray.getDeviceOfOneCity, { ...params })
      if (result) {
        common.ajaxMsg(result.data, false, () => {
          let resData = result.data.data
          let dataList = []

          resData.map(item => {
            const existingMarker = dataList.find(m => m.geometry.lat === (Number(item.lat)) && m.geometry.lng === Number(item.lon));

            if(existingMarker){
              const { latOffset, lngOffset } = this.getRandomOffset();
              dataList.push({
                geometry: {
                  type: 'Point',
                  coordinates: [item.lon * 1+ lngOffset, item.lat * 1+ latOffset],
                  lng: item.lon * 1 + lngOffset,
                  lat: item.lat * 1 + latOffset,
                  // coordinates: [120.800046, 31.315556],
                  // lng: 120.800046,
                  // lat: 31.315556
                },
                properties: {
                  icon: require(`@/static/images/loc_${this.iconColor}_26.png`),
                  width: 20,
                  height: 30,
                  serialNumber: item.serialNumber || '',
                  baseType:item.baseType || ''
                }
              })
            }else{
              dataList.push({
                geometry: {
                  type: 'Point',
                  coordinates: [item.lon * 1, item.lat * 1],
                  lng: item.lon * 1 ,
                  lat: item.lat * 1 ,
                  // coordinates: [120.800046, 31.315556],
                  // lng: 120.800046,
                  // lat: 31.315556
                },
                properties: {
                  icon: require(`@/static/images/loc_${this.iconColor}_26.png`),
                  width: 20,
                  height: 30,
                  serialNumber: item.serialNumber || '',
                  baseType:item.baseType || ''
                }
              })
            }


          })
          this.deviceList = dataList

          console.log('dataListdataList',dataList)
          // this.deviceList = [
          //   {
          //     geometry: {
          //       type: 'Point',
          //       coordinates: [138.730331, 35.363075],
          //       lng: 138.730331,
          //       lat: 35.363075
          //     },
          //     properties: {
          //       icon: require(`@/static/images/loc_${this.iconColor}_26.png`),
          //       width: 20,
          //       height: 30,
          //       serialNumber: '123456789' || ''
          //     }
          //   },
          //   {
          //     geometry: {
          //       type: 'Point',
          //       coordinates: [138.730331, 35.363075],
          //       lng: 138.730331,
          //       lat: 35.363075
          //     },
          //     properties: {
          //       icon: require(`@/static/images/loc_${this.iconColor}_26.png`),
          //       width: 20,
          //       height: 30,
          //       serialNumber: '458787878' || ''
          //     }
          //   },
          //   {
          //     geometry: {
          //       type: 'Point',
          //       coordinates: [139.77604, 35.71632],
          //       lng: 139.77604,
          //       lat: 35.71632
          //     },
          //     properties: {
          //       icon: require(`@/static/images/loc_${this.iconColor}_26.png`),
          //       width: 20,
          //       height: 30,
          //       serialNumber: '5457889789789' || ''
          //     }
          //   },

          // ]
          // console.log('this.deviceList', this.deviceList)
        });
      }
      this.loading = false
    },

   async searchData() {//搜索

      this.iconIndex = (this.searchObj.whetherOnline === undefined || this.searchObj.whetherOnline === '') ? 2 : this.searchObj.whetherOnline
      if (this.iconIndex == 2) {
        this.iconColor = '#1296db'
      } else if (this.iconIndex == 1) {
        this.iconColor = '#00a859'
      } else if (this.iconIndex == 0) {
        this.iconColor = '#d81e06'
      }
      this.loading = true
      this.dataCityList = []

      if (this.zoom==4) {
        this.removePoints()
        
        // 获取可视区域国家列表
        await this.getVisibleRegionCountry()

        await this.getInitData(this.countryListMove)
          // 渲染地图
        await this.echarsHeatmap();
        this.loading = false
      }else{

        this.map.setZoom(4);
        this.map.setCenter({ lat: this.centerGeo.lat, lng: this.centerGeo.lng })
        this.removePoints()
        this.loading = false
      }

    },

    getVisibleRegionCountry() {//获取可视区域内所有国家的信息
      var bounds = this.map.getBounds();
      var ne = bounds.getNorthEast();
      var sw = bounds.getSouthWest();
      const viewport = {
        north: ne.lat(),
        south: sw.lat(),
        east: ne.lng(),
        west: sw.lng(),
      };

      // console.log(viewport)


      // 方式二、通过可视区域经纬度与json列表里的国家进行对比
      let countryListMove = []
      countryListJson.map((item) => {
        if (item.lng >= viewport.west && item.lng <= viewport.east && item.lat >= viewport.south && item.lat <= viewport.north) {
          countryListMove.push(item.two_letter_code)
        }
      })

      this.countryListMove = countryListMove

      // console.log('this.countryListMove', countryListMove)
    },

    // 谷歌地图api，根据address获取经纬度
    geocodeSync(address) {
      return new Promise((resolve, reject) => {
        this.geocoder.geocode({ address }, (results, status) => {
          if (status === "OK") {
            resolve(results[0]);
          } else {
            reject(status);
          }
        });
      });
    },

    removePoints() {//清除坐标点
      if (this.markerClusterer) {
        this.markerClusterer.clearMarkers()
      }

      if (this.lableMarkers.length) {

        for (let i = 0; i < this.lableMarkers.length; i++) {
          this.lableMarkers[i].setMap(null)
        }
        this.lableMarkers = []
      }

      if (this.infoWindowPOint) {
        this.infoWindowPOint.close()
      }

    },

    // 自定义标签展示
    async getLabelLayer() {

      // console.log(999)

      let map = this.map
      let list = (this.dataCityList.length == 0 || this.level == 1) ? [...this.dataCountryList] : [...this.dataCityList];

      for (let i = 0; i < list.length; i++) {
        // 如果有为0的数据就不展示
        if (list[i].geometry === null) {
          return;
        }

        let marker = new MarkerWithLabel({
          position: { lat: list[i].geometry.lat, lng: list[i].geometry.lng },
          icon: {
            url: require(`@/static/images/xinxi${this.iconColor}.png`), // 你的 icon 路径
            scaledSize: new google.maps.Size(60, 60), // icon 的位置
            //origin: new google.maps.Point(0, 0), // origin
            // labelOrigin: { x: 25, y: 50} // label 的位置
          },
          draggable: false, // 是否可拖动
          map: map, // 绑定的地图实例
          labelContent: list[i].properties.text,
          labelAnchor: new google.maps.Point(20, 38), // label 的位置
          labelClass: 'labels',  // label 的 class
          labelStyle: {}
        });
        marker.addListener("click", async (e) => { // 为标记添加点击事件

          if (this.dataCityList.length == 0 || this.level == 1) {

            this.countryClick = true
            await this.getCityDataByCounty(list[i].properties.country)
            await this.getLabelLayer()
            map.setCenter({ lat: list[i].geometry.lat, lng: list[i].geometry.lng }) // 每次点击标记会将地图的中心定位到标记
            let zoom = (this.zoom >= 5 && this.zoom <= 9) ? this.zoom : 5
            map.setZoom(zoom);
            this.countryClick = false
          }

          // if (this.level == 2) {
          if (this.dataCityList.length > 0) {
            // console.log('e', e)
            this.IconClusterClick = true
            await this.getDetailData(list[i].properties.country, list[i].properties.city)

            let zoom = (this.zoom >= 12) ? this.zoom : 12
            map.setZoom(zoom);
            await this.getIconClusterLayer()

            // console.log('this.deviceList[0]',this.deviceList[0])
            if (this.deviceList[0].geometry) map.setCenter({ lat: this.deviceList[0].geometry.lat, lng: this.deviceList[0].geometry.lng }) // 每次点击标记会将地图的中心定位到标记
          }



        })

        // console.log('list',list)

        this.lableMarkers.push(marker)

      }



    },
    // 聚合展示
    getIconClusterLayer() {
      let that = this
      this.removePoints();
      this.markerClusterer = null;

      if (!this.deviceList.length) return
      const markers = []
      this.deviceList.map((item) => {


        var markersItem = new google.maps.Marker({
          icon: require(`@/static/images/loc_${this.iconColor}_26.png`),
          position: { lat: item.geometry.lat, lng: item.geometry.lng },
          label: '',
          title: '',
          serialNumber: item.properties.serialNumber,
          baseType: item.properties.baseType
        });

        markers.push(markersItem)
      })




      // 创建渲染器,可修改文字样式及显示集群的图片

      const renderer = {
        render: (cluster) => {
          // let title = cluster.markers[0].title || ''
          return new google.maps.Marker({
            label: { text: String(cluster.count), color: "white", fontSize: "14px" },
            // label: { text: title, color: "white", fontSize: "14px" },
            position: cluster.position,
            icon: {
              //设置集群的图片
              url: require(`@/static/images/xinxi${this.iconColor}.png`),
              scaledSize: new google.maps.Size(62, 42),
            },
            // 设置zIndex
            zIndex: Number(google.maps.Marker.MAX_ZINDEX) + cluster.count,

          })
        }

      };


      // 创建一个聚合方法
      const setClusters = (markers) => {
        return new MarkerClusterer({ markers: markers, map: this.map, renderer })

      }

      this.markerClusterer = setClusters(markers);



      // 遍历单个标记数组，为每个标记添加点击事件
      for (let i = 0; i < markers.length; i++) {
        let marker = markers[i];
        let infowindow = null; // 每个标记一个独立的 InfoWindow
      
        marker.addListener('click', function () {
          // 如果当前标记的 InfoWindow 已经存在且打开，关闭它
          if (infowindow && infowindow.getMap()) {
            infowindow.close(); // 关闭当前 InfoWindow
          } else {
            // 如果没有打开的 InfoWindow 或者是第一次点击该标记，创建新的 InfoWindow
            infowindow = new google.maps.InfoWindow({
              content: `
                <div>
                  <div>${that.$t("deviceManage.serialNumber")}: ${marker.serialNumber}</div>
                  <div>${that.$t("deviceManage.baseType")}: ${marker.baseType}</div>
                </div>
              `
            });
      
            // 打开 InfoWindow
            infowindow.open(that.map, marker);
          }
        });
      }







    },

  },


}
</script>
<style lang="less" scoped>
.mapdiv {
  width: 100%;
  min-width: 600px;
  min-height: 600px;
  padding: 0 60px;
  position: relative;
}

#allmap {
  width: 100%;
  min-width: 600px;
  height: 600px;
  margin: 20px auto;
  position: relative;
}


/deep/ .labels {
  color: white;
  // background-color: white;   
  font-size: 10px;
  font-weight: bold;
  text-align: center;
  width: 40px;
  // border: 2px solid black;  
  white-space: nowrap;
}

/deep/ .gm-fullscreen-control {
  display: none !important;
}

.errTip {
  position: absolute;
  left: 50%;
  z-index: 99;
  top: 50%;
  width: 200px;
  height: 200px;
  background-color: white;
  transform: translate(-50%, -50%);
  line-height: 200px;
  text-align: center;
  font-size: 24px;
}
</style>